import React, { createContext, useContext, useState, useMemo } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

const DashboardUIContext = createContext(null);

export function DashboardUIProvider({ children }) {
  const [loading, setLoading] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);
  const [gatherData, setGatherData] = useState([]);
  const [projectionData, setProjectionData] = useState([]);
  const [forecastDays, setForecastDays] = useState([]);
  const [calibratedForecastData, setCalibratedForecastData] = useState([]);
  const [beginDateChart, setBeginDateChart] = useState(null);
  const [endDateChart, setEndDateChart] = useState(null);
  const [charts, setCharts] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerHeight, setDrawerHeight] = useState('80%');
  const [deviceButtonHovered, setDeviceButtonHovered] = useState(false);
  const [openBlockedModal, setOpenBlockedModal] = useState(false);

  const themeButton = useTheme();
  const isLgScreen = useMediaQuery(themeButton.breakpoints.down('lg'));

  const value = useMemo(
    () => ({
      loading,
      setLoading,
      isUpdating,
      setIsUpdating,
      gatherData,
      setGatherData,
      projectionData,
      setProjectionData,
      forecastDays,
      setForecastDays,
      calibratedForecastData,
      setCalibratedForecastData,
      beginDateChart,
      setBeginDateChart,
      endDateChart,
      setEndDateChart,
      charts,
      setCharts,
      isDrawerOpen,
      setIsDrawerOpen,
      drawerHeight,
      setDrawerHeight,
      deviceButtonHovered,
      setDeviceButtonHovered,
      openBlockedModal,
      setOpenBlockedModal,
      isLgScreen,
    }),
    [
      loading,
      isUpdating,
      gatherData,
      projectionData,
      forecastDays,
      calibratedForecastData,
      beginDateChart,
      endDateChart,
      charts,
      isDrawerOpen,
      drawerHeight,
      deviceButtonHovered,
      openBlockedModal,
      isLgScreen,
    ]
  );

  return <DashboardUIContext.Provider value={value}>{children}</DashboardUIContext.Provider>;
}

export function useDashboardUIContext() {
  const context = useContext(DashboardUIContext);
  if (!context) {
    throw new Error('useDashboardUIContext deve ser usado dentro de DashboardUIProvider');
  }
  return context;
}
